import UmTab from "../../../../patient/details/um/UmTab";

export default function UMDrawerTab({classes, goToCaseTabHandler, column = 5, inWorkQ}) {
    return <div className={`${classes.block} ${classes[`block_${column}`]}`}>
        <UmTab inWorkQ={inWorkQ} />
    </div>
}
